export interface CartItemModel {
  id: string;
  productId: string;
  name: string;
  sku: string;
  price: number;
  quantity: number;
  imageUrl?: string;
  coolingCapacityBtu?: number | null;
  brandName?: string;
}

export interface CartCalculationResult {
  subtotal: number;
  discountAmount: number;
  shippingCost: number;
  taxAmount: number;
  totalAmount: number;
  isFreeShipping: boolean;
}

export const FREE_SHIPPING_THRESHOLD = 10000;
export const STANDARD_SHIPPING_FEE = 500;
export const STANDARD_TAX_RATE = 0.20; // 20% TVSH (included in retail price as standard in Albania)

export function calculateCartTotals(
  items: { price: number; quantity: number }[],
  discountPercent: number = 0,
  fixedDiscount: number = 0
): CartCalculationResult {
  const subtotal = items.reduce((acc, item) => acc + item.price * item.quantity, 0);

  let discountAmount = 0;
  if (discountPercent > 0) {
    discountAmount += (subtotal * discountPercent) / 100;
  }
  if (fixedDiscount > 0) {
    discountAmount += fixedDiscount;
  }
  discountAmount = Math.min(discountAmount, subtotal);

  const discountedSubtotal = subtotal - discountAmount;
  const isFreeShipping = discountedSubtotal >= FREE_SHIPPING_THRESHOLD || items.length === 0;
  const shippingCost = isFreeShipping ? 0 : STANDARD_SHIPPING_FEE;

  // TVSH 20% calculation (Tax is embedded in gross retail price: Tax = Gross * (0.20 / 1.20))
  const taxAmount = Math.round(discountedSubtotal * (STANDARD_TAX_RATE / (1 + STANDARD_TAX_RATE)));
  const totalAmount = discountedSubtotal + shippingCost;

  return {
    subtotal,
    discountAmount,
    shippingCost,
    taxAmount,
    totalAmount,
    isFreeShipping,
  };
}
